import { Avatar, type AvatarProps } from '@/components/ui/Avatar';
import { usePatientPhoto } from '@/hooks/usePatientPhoto';

interface PatientAvatarProps extends Omit<AvatarProps, 'src'> {
  patientId: number | string | null | undefined;
  photoUrl?: string | null;
}

export function PatientAvatar({
  patientId,
  photoUrl,
  name,
  size = 'md',
  className,
  status,
}: PatientAvatarProps) {
  const src = usePatientPhoto(patientId, photoUrl);

  return (
    <Avatar
      src={src}
      name={name}
      size={size}
      className={className}
      status={status}
    />
  );
}
